export const isIOS = (userAgent = navigator.userAgent) => {
  return Boolean(userAgent && /iPhone|iPad|iPod|\bOS X\b/gi.test(userAgent));
};
